module.exports = __webpack_public_path__ + "img/8.dabbb7e1.svg";